module.exports = __webpack_public_path__ + "audioonly-headset.e8710ab3ce694f43f7b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/opentok/audioonly-headset.svg
// module id = ./src/assets/opentok/audioonly-headset.svg
// module chunks = 2